'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _some2 = require('lodash/some');

var _some3 = _interopRequireDefault(_some2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _reactRouter = require('react-router');

var _common = require('../common');

var _constants = require('../../constants');

var _CaseSearchResultsHeader = require('./CaseSearchResultsHeader');

var _CaseSearchResultsHeader2 = _interopRequireDefault(_CaseSearchResultsHeader);

var _CaseSearchResultsList = require('./CaseSearchResultsList');

var _CaseSearchResultsList2 = _interopRequireDefault(_CaseSearchResultsList);

var _CaseSearchResultsFilterSidebar = require('./CaseSearchResultsFilterSidebar');

var _CaseSearchResultsFilterSidebar2 = _interopRequireDefault(_CaseSearchResultsFilterSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var USER_FLOW = _constants.AppConstants.USER_FLOW;
var CaseSearchResultsPage = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'FunderStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSearchResultsPage, _Component);

  function CaseSearchResultsPage() {
    _classCallCheck(this, CaseSearchResultsPage);

    return _possibleConstructorReturn(this, (CaseSearchResultsPage.__proto__ || Object.getPrototypeOf(CaseSearchResultsPage)).apply(this, arguments));
  }

  _createClass(CaseSearchResultsPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setStateFromProps(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var FunderStore = this.props.FunderStore;

      FunderStore.fetchFunderTemplates();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setStateFromProps(nextProps);
    }
  }, {
    key: 'setStateFromProps',
    value: function setStateFromProps(props) {
      var UiStore = props.UiStore;

      UiStore.caseSearchResultsPage.setFromProps(props);
    }
  }, {
    key: 'getLawFirmFromResults',
    value: function getLawFirmFromResults(results) {
      var resultWithLawFirm = (0, _find3.default)(results, 'lawfirm');
      return resultWithLawFirm && resultWithLawFirm.lawfirm;
    }
  }, {
    key: 'onFilterChange',
    value: function onFilterChange(filterMetadata) {
      var _props = this.props,
          pathname = _props.location.pathname,
          UiStore = _props.UiStore,
          caseSearchResultsPage = UiStore.caseSearchResultsPage,
          query = (0, _omit3.default)(caseSearchResultsPage.query, ['app_status', 'case_is_open']);

      _reactRouter.browserHistory.push({ pathname: pathname, query: Object.assign(query, filterMetadata.filter_params) });
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(id) {
      _reactRouter.browserHistory.push({ pathname: '/case/' + id + '/details/feed', state: USER_FLOW.FROM_SEARCH_RESULTS });
    }
  }, {
    key: 'onLoadMoreClick',
    value: function onLoadMoreClick() {
      var _props2 = this.props,
          UiStore = _props2.UiStore,
          CaseStore = _props2.CaseStore;

      UiStore.caseSearchResultsPage.loadMore(CaseStore);
    }
  }, {
    key: 'renderFilters',
    value: function renderFilters() {
      var _props3 = this.props,
          CaseStore = _props3.CaseStore,
          UiStore = _props3.UiStore,
          query = UiStore.caseSearchResultsPage.query,
          searchFiltersMeta = CaseStore.searchFiltersMeta,
          selectedFilterMetadata = searchFiltersMeta.reverse().find(function (filterMetadata) {
        return (0, _some3.default)([query], filterMetadata.filter_params);
      });


      return _react2.default.createElement(_CaseSearchResultsFilterSidebar2.default, {
        filterMetadata: (0, _mobx.toJS)(searchFiltersMeta),
        onFilterChange: this.onFilterChange,
        selectedFilter: selectedFilterMetadata && selectedFilterMetadata.name
      });
    }
  }, {
    key: 'renderResults',
    value: function renderResults() {
      var _props4 = this.props,
          CaseStore = _props4.CaseStore,
          UiStore = _props4.UiStore,
          _UiStore$caseSearchRe = UiStore.caseSearchResultsPage,
          isLoading = _UiStore$caseSearchRe.isLoading,
          resultKey = _UiStore$caseSearchRe.resultKey,
          headerObject = _UiStore$caseSearchRe.headerObject,
          caseQueryResult = CaseStore.queryResults[resultKey];


      if (!caseQueryResult) {
        return _react2.default.createElement(_common.Loader, { className: 'page-loader', logo: true });
      }

      var hasNextPage = caseQueryResult.hasNextPage,
          items = caseQueryResult.items,
          lawfirm = this.getLawFirmFromResults(items);


      return _react2.default.createElement(
        'div',
        { className: 'case-search-results-list' },
        _react2.default.createElement(_CaseSearchResultsHeader2.default, {
          headerObject: headerObject,
          headerType: this.fieldUserSearchedBy,
          lawfirm: lawfirm
        }),
        _react2.default.createElement(_CaseSearchResultsList2.default, {
          fieldUserSearchedBy: this.fieldUserSearchedBy,
          hasMoreResults: hasNextPage,
          isLoading: isLoading,
          items: (0, _mobx.toJS)(items),
          onItemClick: this.onItemClick,
          onLoadMoreClick: this.onLoadMoreClick
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _common.Page,
        { name: 'search-results', hasSidebar: true },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Case Search Results' }),
        _react2.default.createElement(
          _common.Page.Sidebar,
          { className: 'dark' },
          this.renderFilters()
        ),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          this.renderResults()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldUserSearchedBy',
    get: function get() {
      var UiStore = this.props.UiStore,
          query = UiStore.caseSearchResultsPage.query,
          possibleFields = ['attorney', 'facility', 'facility_contact', 'lawfirm', 'contacts', 'provider'];

      return possibleFields.find(function (field) {
        return field in query;
      });
    }
  }]);

  return CaseSearchResultsPage;
}(_react.Component), _class2.propTypes = {
  CaseStore: _propTypes2.default.object,
  Clients: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }),
  UiStore: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
var _default = CaseSearchResultsPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/page-case-search-results/CaseSearchResultsPage.js');
  reactHotLoader.register(CaseSearchResultsPage, 'CaseSearchResultsPage', '/app/src/components/page-case-search-results/CaseSearchResultsPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/CaseSearchResultsPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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